<template>
    <div class="w-input">
        <span v-show="!editable">{{ data }}</span>
        <el-input
            v-show="editable"
            class="number-input"
            v-model="weightData"
            ref="autoFocus"
            type="number"
            size="small"
            oninput="if(value){value=value.replace(/[^\d]/g,'')} if(value>9999){value=9999}"
            @blur="emitEditEvent"
            @keyup.enter.native="emitEditEvent"
        ></el-input>
    </div>
</template>

<script>
export default {
    name: "weightInput",
    props: ["data", "row"],
    data() {
        return{
            weightData: this.data
        }
    },
    computed: {
        editable() {
            return this.row.editable;
        },
    },
    watch: {
        editable: {
            handler() {
                this.$nextTick(() => {
                    this.$refs.autoFocus.focus();
                })
                this.weightData = this.data
            },
            deep: true
        }
    },
    methods: {
        emitEditEvent() {
            this.$emit("click", { value: "changeWeight", oldV: this.data, newV: this.weightData })
        }
    }
};
</script>

<style lang="less" scoped>
.w-input {
    .number-input {
        width: 80px;
        ::v-deep .el-input__inner {
            padding-right: 2px;
        }
    }
}
</style>
